import { Injectable } from '@angular/core';
import { isNil } from 'ramda';
import { BehaviorSubject } from 'rxjs';
import { StorageKey, StorageService } from '../storage';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private languageSubject = new BehaviorSubject<string>('');
  public language$ = this.languageSubject.asObservable();

  private readonly STORAGE_KEY = StorageKey.defaultLanguage;

  constructor(private storageService: StorageService) {}

  public setDefaultLanguage(newLanguage: string): void {
    if (typeof newLanguage === 'string' && !isNil(newLanguage)) {
        this.storageService.setItem(this.STORAGE_KEY, newLanguage);

        this.languageSubject.next(newLanguage);
    } else {
        console.error('LanguageService: newLanguage is not a valid string');
    }
  }

  private getDefaultLanguage(languageFromEnvironment: string): string {
    const defaultLanguage = this.storageService.getItem(this.STORAGE_KEY);

    if (typeof defaultLanguage === 'string' && !isNil(defaultLanguage) && defaultLanguage !== '[object Object]') {
      return defaultLanguage;
    }

    return languageFromEnvironment;
  }

  public initCurrentDefaultLanguage(languageFromEnvironment: string): void {
    const currentLanguage = this.getDefaultLanguage(languageFromEnvironment);
    this.languageSubject.next(currentLanguage);
  }
}
